<template>
  <BaseModal
    :show="show"
    @close="close"
  >
    <div class="modal-body text-center mb-8">
      <header class="text-center pb-4 border-b border-grey">
        <h3
          class="mt-0 "
          v-text="'Delete Membership Group'"
        />
      </header>
      <div>
        <div class="flex justify-center items-baseline mt-4">
          <p v-text="'Are you sure you want to delete this membership group? You cannot undo this action.'" />
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn--danger"
        @click.prevent="deleteGroup"
        v-text="'Delete'"
      />
      <a
        class="mx-4 px-2"
        href="#"
        @click.prevent="close"
        v-text="'cancel'"
      />
    </div>
  </BaseModal>
</template>

<script type="text/babel">
import { mapActions, mapState } from 'vuex'

export default {
  name: 'DeleteMembershipGroupModal',
  computed: {
    ...mapState({
      modal: state => state.membership.deleteMembershipGroupModal,
    }),
    membershipGroup() {
      return this.modal.membershipGroup
    },
    show() {
      return this.modal.open
    },
  },
  methods: {
    ...mapActions([
      'membershipDeleteMembershipGroup',
    ]),
    deleteGroup() {
      this.membershipDeleteMembershipGroup(this.membershipGroup.attributes.uuid).then(() => {
        this.$emit('membershipGroupHasBeenDeleted')
      })
    },
    close() {
      this.$store.commit('membershipCloseDeleteMembershipGroupModal')
    },
  },
}
</script>
